<template>
    <div class="footer-warrper" :class="{black:isBlack}">
        Copyright 益魔方 <a :class="{black:isBlack}"  class="margin-left-xs" target="_blank" href="http://beian.miit.gov.cn">京ICP备15038897号-3</a><img class="beian" src="../assets/img/beian.png">
        <a :class="{black:isBlack}" class="margin-right-xs" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038214">京公网安备11010802038214号</a>
    </div>
</template>
<script>
    export default {
        name: "FooterSimpleModular",
        data() {
            return {}
        },
        props: {
            isBlack: {
                type: Boolean,
                default: false
            }
        },
        created() {
        },
        methods: {}
    }
</script>

<style scoped lang="scss">
    .footer-warrper {
        width: 100%;
        height: 39px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        background-color: #0a2240;
        color: #ffffff;
        font-size: 12px;
        &.black {
            background-color: #2f2f2f;
            color: #f5f5f5;
        }
        .beian{
            width: 12px;
            height: 12px;
            margin: 0 5px;
        }
        a {
            font-size: 12px;
            line-height: 12px;
            color: #ffffff;
            &.black {
                color: #f5f5f5;
            }
        }
    }
</style>